module.exports = __webpack_public_path__ + "img/field_list.b4df50f3.png";